<template>
    <div>
        <blog-navigation :blog="blog"/>
        <blog-header :blog="blog"/>
        <posts v-if="init" :blog="blog" type="blog"/>
        <loading-indicator name="blog.getPosts"/>
        <p v-if="noResults" class="text-center">This blog has no posts yet. Please check back later.</p>
        <age-block :accept-action="displayVideo"/>
    </div>
</template>

<script>


  import Posts from '../posts/PostList.vue'
  import PostItem from '../posts/PostListItem.vue';
  import BlogNavigation from '../layout/BlogNavigation.vue';
  import BlogHeader from '../blogs/BlogHeader.vue';
  import AgeBlock from '../layout/AgeBlock.vue';
  import LoadingIndicator from "../ui/LoadingIndicator";

  export default {
    name: 'BlogPage',
    data() {
      return {
        init: false,
        blogUrl: '',
        blog: {},
        posts: [],
        displayVideoId: null,
        meta: {},
        noResults: null
      }
    },
    metaInfo() {
      return this.meta
    },
    mounted() {
      this.blogUrl = this.$route.params.blogUrl;
      if (this.$route.params.videoId) {
        this.displayVideoId = this.$route.params.videoId;
      }
      this.$api.getBlog(this.blogUrl).then((res) => {
        this.blog = res.data.blog;
        this.init = true;

        let absBlogUrl = 'https://pimblr.com/blog/' + this.blog.url;
        let blogTitle = this.blog.title + ' on Pimblr'
        this.meta = {
          title: this.blog.title,
          meta: [
            {vmid: 'description', name: 'description', content: this.blog.description},
            {vmid: 'title', name: 'title', content: this.blog.title},

            {property: 'og:title', content: blogTitle},
            {property: 'og:site_name', content: 'Pimblr'},
            {property: 'og:type', content: 'website'},
            {property: 'og:url', content: absBlogUrl},
            //{property: 'og:image', content: 'https://www.my-site.com/my-special-image.jpg'},

            {name: 'twitter:card', content: 'summary'},
            {name: 'twitter:site', content: absBlogUrl},
            {name: 'twitter:title', content: blogTitle},
            {name: 'twitter:description', content: this.blog.description},

            {itemprop: 'name', content: blogTitle},
            {itemprop: 'description', content: this.blog.description},

          ]
        }
      });

      this.$bus.$on('postlist.noresults', (data) => {
        this.noResults = data.type;
      })

    },
    methods: {
      displayVideo() {
        if (this.displayVideoId) {
          this.$api.getPost(this.displayVideoId)
            .then((res) => {
              const post = res.data.post;
              this.$bus.$emit('playVideo', post);

              const title = post.post.title + " on " + this.blog.title;
              const desc = title + " on " + this.blog.title + " - " + this.blog.description;
              const absBlogUrl = 'https://pimblr.com/blog/' + this.blog.url;

              this.meta = {
                title: post.post.title,
                meta: [
                  {vmid: 'description', name: 'description', content: desc},
                  {vmid: 'title', name: 'title', content: title},

                  {property: 'og:title', content: title},
                  {property: 'og:site_name', content: 'Pimblr'},
                  {property: 'og:type', content: 'website'},
                  {property: 'og:url', content: absBlogUrl},
                  {property: 'og:image', content: post.post.preview},

                  {name: 'twitter:card', content: 'summary'},
                  {name: 'twitter:site', content: absBlogUrl},
                  {name: 'twitter:title', content: title},
                  {name: 'twitter:description', content: desc},

                  {itemprop: 'name', content: title},
                  {itemprop: 'description', content: desc},

                ]
              }


            });
        }
      }
    },
    components: {
      LoadingIndicator,
      Posts,
      PostItem,
      BlogHeader,
      BlogNavigation,
      AgeBlock
    }
  }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/blogs/BlogPage.vue